export default {
  getterScreenInformation: state => state.screenInformation
};
